export const styles = {
  root: { display: 'flex', flexDirection: 'column', gap: 2, padding: 3, minWidth: { md: 560 } },
  tabs: { display: 'flex', gap: 2 },
  row: { display: 'flex', alignItems: 'center', gap: 1.5 },
  text: { flex: 1, display: 'flex', flexDirection: 'column', gap: 0.75 },
}
